import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import makeStyles from '@mui/styles/makeStyles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const useStyles = makeStyles(() => ({
  formControl: {
    marginTop: 0,
    marginBottom: 0,
    width: '100%',
    fontSize: '13px',
  },
}));

const CustomSelect = ({
  value = '',
  onChange,
  label,
  options,
  valueKey,
  labelKey,
  disabled = false,
  error,
  size,
}) => {
  const classes = useStyles();

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      margin="dense"
      error={error}
      size={size}
    >
      <InputLabel id="demo-simple-select-outlined-label" size={size}>
        {label}
      </InputLabel>
      <Select
        error={error}
        disabled={disabled}
        size={size}
        value={valueKey ? value[valueKey] : value ? value : ''}
        onChange={(e) => _.isFunction(onChange) && onChange(e.target.value, e)}
        label={label}
      >
        {options?.map((option, index) =>
          option.isNone ? (
            <MenuItem value="" key={`select${index}`}>
              <em>{option[valueKey] || ''}</em>
            </MenuItem>
          ) : (
            <MenuItem
              value={valueKey ? option[valueKey] : option}
              key={`select${index}`}
            >
              {option[labelKey] || option[valueKey] || option}
            </MenuItem>
          )
        )}
      </Select>
    </FormControl>
  );
};

CustomSelect.propTypes = {
  // value: PropTypes.object,
  label: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
};

export default CustomSelect;
